import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Button } from '@/components/ui/button';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { SimpleModal } from '@/app/components/Modal';
import usePermission from '@/app/hooks/usePermission';

export default function LessonCard({ data, moduleId }) {
  const duration = moment.utc(data.duration * 1000).format('HH:mm:ss');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showModal, setShowModal] = useState(false);

  const bnccPermission = usePermission('Visualizar habilidades BNCC das aulas', 'Cursos');

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <tr className="round-dg__row">
        <th className="round-dg__cell-header round-dg__cell-header--row">
          <div className="round-dg__user">
            <div className="round-dg__user-inner">
              <h3
                className="round-dg__title"
                title={data.body}
              >
                {data.body}
              </h3>
            </div>
          </div>
        </th>
        {bnccPermission && (
          <td className="round-dg__cell">
            <div className="flex gap-1">
              {isMobile && data?.['bncc-skills'].length > 0 ? (
                <Button
                  variant="outline"
                  size="xs"
                  onClick={() => setShowModal(true)}
                >
                  Visualizar
                </Button>
              ) : (
                <>
                  {data?.['bncc-skills'].length > 0
                    ? data?.['bncc-skills'].map(skill => (
                        <span
                          className="badge"
                          data-tooltip-id={skill.id}
                          data-tooltip-content={skill.description}
                          data-tooltip-place="bottom"
                        >
                          {skill.code}
                          <ReactTooltip
                            id={skill.id.toString()}
                            className="tooltip"
                            opacity={1}
                            style={{ backgroundColor: '#F1F5FA', color: '#110B3E', boxShadow: '0px 4px 10px 3px #5D6A8633', maxWidth: '400px', whiteSpace: 'normal', lineHeight: '150%', borderRadius: '8px' }}
                          />
                        </span>
                      ))
                    : '-'}
                </>
              )}
            </div>
          </td>
        )}

        <td className="round-dg__cell">{data['learning-system-files-count']}</td>

        <td className="round-dg__cell">{duration}</td>

        <td className="round-dg__cell">
          <Button
            variant="outline"
            size="xs"
            fullWidth
            asChild
          >
            <Link to={`/show-course/${moduleId}/classroom/${data.id}`}>Assistir aulas</Link>
          </Button>
        </td>
      </tr>
      <SimpleModal
        show={showModal}
        onClose={() => setShowModal(false)}
        contentClassName="!bg-[#F1F5FA]"
      >
        {data?.['bncc-skills']?.map(skill => (
          <div>
            <h6 className="text-[12px] text-primary-dark">Código: {skill.code}</h6>
            <p>{skill.description}</p>
          </div>
        ))}
      </SimpleModal>
    </>
  );
}
